import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

type CustomDatePickerProps = {
  label?: string;
  customFormat?: "YYYY/MM/DD" | "DD/MM/YYYY" | "MM/DD/YYYY";
  dateHelperText?: boolean;
  value: any;
  onChange: Function;
};
export default function CustomDatePicker({
  label = "",
  value,
  onChange,
  customFormat = "YYYY/MM/DD",
  dateHelperText = false,
}: CustomDatePickerProps) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        slotProps={{
          desktopPaper: {
            sx: {
              p: 0,
            },
          },
          textField: {
            helperText: dateHelperText ? customFormat : null,
            size: "small",
            color: "secondary",
            sx: { color: "secondary" },
            label: label,
          },
        }}
        views={["year", "month", "day"]}
        format={customFormat}
        defaultValue={null}
        sx={{ color: "secondary" }}
        // maxDate={dayjs(new Date().toISOString())}
        value={dayjs(value)}
        onChange={(e) => {
          if (e) {
            onChange(dayjs(e).toDate());
          }
        }}
      />
    </LocalizationProvider>
  );
}
